export function stringToBoolean(str) {
  if (str?.toLowerCase() === 'true') {
    return true;
  } else if (str?.toLowerCase() === 'false') {
    return false;
  } else {
    // Handle other cases if needed
    return null;
  }
}